import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RecentMessages = ({ messages, onViewAllMessages }) => {
  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const messageTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - messageTime) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return messageTime?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-soft">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-foreground">Recent Messages</h2>
          <Button
            variant="ghost"
            size="sm"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={onViewAllMessages}
          >
            View All
          </Button>
        </div>
      </div>
      <div className="divide-y divide-border max-h-96 overflow-y-auto">
        {messages?.length > 0 ? (
          messages?.map((message) => (
            <div
              key={message?.id}
              className="p-4 hover:bg-muted/50 cursor-pointer transition-colors"
              onClick={() => onViewAllMessages(message?.enquiryId)}
            >
              <div className="flex items-start space-x-3">
                <div className="relative flex-shrink-0">
                  <Image
                    src={message?.agentAvatar}
                    alt={message?.agentAvatarAlt}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  {message?.unread && (
                    <div className="absolute -top-1 -right-1 w-3 h-3 bg-accent rounded-full border-2 border-card"></div>
                  )}
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <div className="flex items-center space-x-2">
                      <h4 className="text-sm font-medium text-foreground truncate">
                        {message?.agentName}
                      </h4>
                      <span className="text-xs text-muted-foreground">
                        • {message?.enquiryDestination}
                      </span>
                    </div>
                    <span className="text-xs text-muted-foreground flex-shrink-0">
                      {formatTimestamp(message?.timestamp)}
                    </span>
                  </div>
                  
                  <p className="text-sm text-muted-foreground line-clamp-2 mb-2">
                    {message?.lastMessage}
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      {message?.hasAttachment && (
                        <Icon name="Paperclip" size={12} className="text-muted-foreground" />
                      )}
                      {message?.unread && (
                        <span className="text-xs font-medium text-accent">New</span>
                      )}
                    </div>
                    <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="p-8 text-center">
            <Icon name="MessageCircle" size={32} className="mx-auto mb-3 text-muted-foreground opacity-50" />
            <p className="text-sm text-muted-foreground mb-1">No messages yet</p>
            <p className="text-xs text-muted-foreground">
              Messages from travel agents will appear here
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentMessages;